module.exports = __webpack_public_path__ + "b75ab0c31cb162da6dcff093a5531eed.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/luxury-apartments.png
// module id = 2839
// module chunks = 0